import { render, staticRenderFns } from "./AppDownloadCommunityOrganization.vue?vue&type=template&id=1c30bf4a&scoped=true"
import script from "./AppDownloadCommunityOrganization.vue?vue&type=script&lang=js"
export * from "./AppDownloadCommunityOrganization.vue?vue&type=script&lang=js"
import style0 from "./AppDownloadCommunityOrganization.vue?vue&type=style&index=0&id=1c30bf4a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c30bf4a",
  null
  
)

export default component.exports